// @flow
import usePermissions from 'hooks/usePermissions'
import useScreenSizeStyle from 'hooks/useScreenSizeStyle'
import * as React from 'react'
import { Link } from 'react-router-dom'
import type { Customer } from 'types/customer'
import Table from 'ui/atoms/Table'
import Text from 'ui/atoms/Text'
import Tooltip from 'ui/atoms/Tooltip'
import { buildFullName } from 'utils/helpers'

type Props = {
  customer: ?Customer,
  disabled: boolean,
  popup: React.Node,
  resourceLink: string,
  resourceName: string,
  status: string | React.Node,
}

function DashboardTableRow({
  customer,
  disabled,
  popup,
  resourceLink,
  resourceName,
  status,
}: Props): React.Node {
  const { canViewClientProfile } = usePermissions()

  const textSize = useScreenSizeStyle({
    md: { small: true, xsmall: false },
    generic: { small: false, xsmall: true },
  })

  const maxWidthText = useScreenSizeStyle({
    md: '170px',
    generic: '110px',
  })

  const compact = useScreenSizeStyle({ md: false, generic: true })

  const fullName = customer?.is_anonymous
    ? 'Anonymous'
    : buildFullName(customer?.first_name, customer?.last_name)

  return (
    <Table.Row disabled={disabled}>
      <Table.Column $compact={compact}>
        {!customer?.id ? (
          <Text $muted $small={textSize.small} $xsmall={textSize.xsmall}>
            Client Missing
          </Text>
        ) : customer?.is_anonymous ? (
          <Text $muted $small={textSize.small} $xsmall={textSize.xsmall}>
            Anonymous
          </Text>
        ) : (
          <Text
            $medium
            $truncate
            $small={textSize.small}
            $xsmall={textSize.xsmall}
            style={{ maxWidth: maxWidthText }}
          >
            {canViewClientProfile ? (
              <Link to={`clients/${customer.id || 'no_client'}`}>
                {fullName}
              </Link>
            ) : (
              fullName
            )}
          </Text>
        )}
      </Table.Column>
      <Table.Column $compact={compact}>
        <Tooltip
          enabled={resourceName?.length > 23}
          label={resourceName}
          mouseEnterDelay={1}
        >
          <Text
            $light
            $truncate
            $small={textSize.small}
            $xsmall={textSize.xsmall}
            style={{ maxWidth: maxWidthText }}
          >
            <Link to={resourceLink}>{resourceName}</Link>
          </Text>
        </Tooltip>
      </Table.Column>
      <Table.Column $compact={compact}>
        {typeof status === 'string' ? (
          <Text $light $small={textSize.small} $xsmall={textSize.xsmall}>
            {status}
          </Text>
        ) : (
          status
        )}
      </Table.Column>
      <Table.Column $compact={compact}>{popup}</Table.Column>
    </Table.Row>
  )
}

export default DashboardTableRow
